import { render } from "./AposBreadcrumbOperations.vue?vue&type=template&id=2915a6b4&scoped=true"
import script from "./AposBreadcrumbOperations.vue?vue&type=script&lang=js"
export * from "./AposBreadcrumbOperations.vue?vue&type=script&lang=js"

import "./AposBreadcrumbOperations.vue?vue&type=style&index=0&id=2915a6b4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2915a6b4"],['__file',"area/ui/apos/components/AposBreadcrumbOperations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2915a6b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2915a6b4', __exports__)) {
    api.reload('2915a6b4', __exports__)
  }
  
  module.hot.accept("./AposBreadcrumbOperations.vue?vue&type=template&id=2915a6b4&scoped=true", () => {
    api.rerender('2915a6b4', render)
  })

}


export default __exports__